import "../../assets/css/community-progress.css";
import { useContext, useState, useEffect } from "react";
import StateContext from "../../state/stateContext";
import useQueryCommunityNews from "../Hooks/useQueryCommunityNews";
import useQueryChildData from "../Hooks/useQueryChildData";
import { CommunityProgressPhaseOne } from "./CommunityProgressPhaseOne";
import { CommunityProgressPhaseTwo } from "./CommunityProgressPhaseTwo";
import { CommunityProgressPhaseThree } from "./CommunityProgressPhaseThree";
import { CommunityProgressPhaseFour } from "./CommunityProgressPhaseFour";
import dayjs from 'dayjs';

function getCommunityPhase(fieldStatus, activeYears) {
  let communityPhaseNumber = 3; 

  if (fieldStatus.toLowerCase() === "closed" || fieldStatus.toLowerCase() === "archive") {
    // Closed
    communityPhaseNumber = 4;
  } else if (activeYears < 4) {
    communityPhaseNumber = 1;
  } else if (activeYears >= 4 && activeYears < 10) {
      communityPhaseNumber = 2;
  } else {
      communityPhaseNumber = 3;
  }

  return communityPhaseNumber; 

}

// Given a start date unix timestamp, return the number of active years 
function getActiveYears(startDateUnixTimestamp) {
  // if start Date is null? 
  if (startDateUnixTimestamp === null) {
    return 0; 
  }

  const startDate = dayjs(startDateUnixTimestamp * 1000);
  const activeYears = dayjs().diff(startDate, 'year');
  return activeYears;
}

function CommunityProgress(props) {
  const context = useContext(StateContext);
  const [communityPhase, setCommunityPhase] = useState(1);
  const [selectedPhase, setSelectedPhase] = useState(0);
  const queryChildData = useQueryChildData(context);
  const queryCommunityNews = useQueryCommunityNews(context);
  

  useEffect(() => {
    if (queryChildData.isSuccess && queryCommunityNews.isPending) {
       const { projectIdentifier } = queryChildData?.data || {};
       queryCommunityNews.request(projectIdentifier);
    } 
 }, [queryChildData, queryCommunityNews]);

 useEffect(() => {
  if (queryCommunityNews.isSuccess) {
    const startDate = queryCommunityNews.data.startDate;
    const projectStatus = queryCommunityNews.data.projectStatus;
    
    // Convert ISO date string to timestamp for getActiveYears
    const startTimestamp = startDate ? new Date(startDate).getTime() / 1000 : null;
    const activeYears = getActiveYears(startTimestamp);
    
    // Map projectStatus to appropriate status for getCommunityPhase
    // If "Closed" or contains "Closed", set to "archive", otherwise use as is
    const mappedStatus = projectStatus?.toLowerCase().includes("closed") ? "archive" : projectStatus;
    
    const communityPhase = getCommunityPhase(mappedStatus, activeYears);
    setCommunityPhase(communityPhase);
  } 
}, [queryCommunityNews]);

  if (queryCommunityNews.isError) {
    // Do Not Display Community Progress
    return null;
  }

  const handleOnChange = (e, phase) => {
   setSelectedPhase(phase);
  }

  const loading = queryCommunityNews.isWaiting;

  const phaseToShow = selectedPhase > 0 ? selectedPhase : communityPhase;

  switch (phaseToShow){
    case (4):
      return <CommunityProgressPhaseFour loading={loading} handleOnChange={handleOnChange} communityPhase={communityPhase}/>

    case (3):
      return <CommunityProgressPhaseThree loading={loading} handleOnChange={handleOnChange} communityPhase={communityPhase}/>
 
    case (2):
      return <CommunityProgressPhaseTwo loading={loading} handleOnChange={handleOnChange} communityPhase={communityPhase}/>
    
    default:
      return <CommunityProgressPhaseOne loading={loading} handleOnChange={handleOnChange} communityPhase={communityPhase}/>
  }


}
  
export default CommunityProgress;